import React from "react";
const Subscription = () => {
  return <h1>Subscriptions</h1>;
};
export default Subscription;
